import { graphql } from '@/graphql/__generated/gql';

export const cacheKey = 'featureFlags';

export const FEATURE_FLAG_NAMES = {
    KETCH_ENABLED: 'tn_ketch_enabled',
    FOOTER_HUB_LINKS_USE_FEATURED: 'tn_footer_hub_links_use_featured',
    RETURNING_USER_LIVE_TV_REDIRECT: 'ptv_returning_user_livetv_redirect',
    MOBILE_VIDEO_PLAYBACK_ENABLED: 'mobile_video_playback_enabled',
    UNIFIED_IDENTITY_PLATFORM: 'unified_identity_platform',
} as const;
export const query = graphql(/* GraphQL */ `
    query FeatureFlags {
        featureFlags
    }
`);
